export default __webpack_public_path__ + "static/media/information-popUp.98e81799.svg";